import React from "react";
import "./Sections.scss";

function Section1() {
  return (
    <section className="sections sections-section1">
      <p className="sections-copy">
        These are challenging times for anyone shopping for a new home in
        America. “Right now, we have incredibly low housing inventory—the lowest
        we have seen dating back to the 1980s,” says{" "}
        <a
          className="hyperLink"
          href="https://www.nar.realtor/jessica-lautz"
          target="_blank"
          rel="noreferrer"
        >
          Dr. Jessica Lautz, Vice President of Demographics and Behavioral
          Insights
        </a>{" "}
        at the National Association of REALTORS® (NAR). “It’s very difficult for
        first-time home buyers to enter the market in such an environment.”
      </p>
      <p className="sections-copy">
        With low supply and high demand, prices are on the rise and homes are
        selling fast. In some locations, sellers may get multiple offers at or
        above asking price as soon as their home hits the market. Factors like
        price, condition of the property , and time of year can also influence
        how many offers a seller receives. Meanwhile, aspiring homeowners may
        face competition from both individuals and{" "}
        <a
          className="hyperLink"
          href="https://www.nar.realtor/blogs/economists-outlook/cash-sales-rise-to-23-with-growing-entry-of-ibuyers-and-fin-tech-companies"
          target="_blank"
          rel="noreferrer"
        >
          corporate buyers
        </a>
        , some of whom are able to make all-cash offers.
      </p>
      <p className="sections-copy">
        What can buyers—especially first-time buyers and others who don’t have
        massive piles of cash—do in such circumstances?
      </p>
      <p className="sections-copy">
        For one thing, buyers can broaden their horizons beyond pricey city
        centers. In fact, NAR research shows that homebuyers of all ethnicities
        and ages are moving to suburbs and small towns. “Typically, it was older
        generations that bought homes in suburbia, but nowadays younger
        generations are buying their first homes in the suburbs too,” explains
        Lautz.
      </p>
    </section>
  );
}

export default Section1;
